import { ReactElement } from 'react';

const LinkedinIcon = (props: TClassNameProps): ReactElement => (
	<svg width="19" height="18" viewBox="0 0 19 18" fill="none" {...props}>
		<path
			d="M3.92135 18H0.064209V5.14282H3.92135V18ZM18.0642 18H14.2071V11.1317C14.2071 9.34197 13.5694 8.45096 12.3055 8.45096C11.3039 8.45096 10.6688 8.94982 10.3499 9.94882C10.3499 11.5714 10.3499 18 10.3499 18H6.49278C6.49278 18 6.54421 6.42854 6.49278 5.14282H9.53735L9.77264 7.71425H9.85235C10.6431 6.42854 11.9069 5.55682 13.6401 5.55682C14.9579 5.55682 16.0238 5.92325 16.8376 6.84382C17.6566 7.76568 18.0642 9.00254 18.0642 10.7395V18Z"
			fill="currentColor"
		/>
		<path
			d="M1.99286 3.85714C3.09348 3.85714 3.98571 2.99369 3.98571 1.92857C3.98571 0.863451 3.09348 0 1.99286 0C0.892233 0 0 0.863451 0 1.92857C0 2.99369 0.892233 3.85714 1.99286 3.85714Z"
			fill="currentColor"
		/>
	</svg>
);

export default LinkedinIcon;
